import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { GestionAfiliadoService } from '../../services/gestionafiliado.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { GestionAfiliado_Parametro } from '../../models/generic/GestionAfiliado_Parametro';
import { GestionAfiliado_Cartera } from 'src/app/models/generic/GestionAfiliado_Cartera';
import { GestionAfiliado } from 'src/app/models/generic/GestionAfiliado';
import { Constantes } from 'src/app/models/modules/Constantes';

@Component({
  selector: 'gestion-afiliados-cartera',
  templateUrl: './gestion-afiliados-cartera.component.html',
  styleUrls: ['./gestion-afiliados-cartera.component.scss']
})
export class GestionAfiliadosCarteraComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<GestionAfiliado_Cartera>;
  columnasEncabezado: string[] = ['annio', 'mes', 'recaudo', 'fechaRecaudo', 'producto', 'valorCobro'];
  listaDatos: GestionAfiliado_Cartera[] = [];
  parametrosPrincipal: GestionAfiliado_Parametro;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public gestionAfiliadoService: GestionAfiliadoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.IniciarFormulario();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);

    this.form.get('id').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].id);
    this.form.get('idProducto').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProducto);
    this.form.get('idProductoUnico').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoUnico);
    this.form.get('producto').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].producto);
    this.form.get('idAplicacion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idAplicacion);
    this.form.get('idAliado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idAliado);
    this.form.get('nroDocumento').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroDocumento);
    this.form.get('nombresApellidos').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nombresApellidos);
    this.form.get('fechaAfiliacion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].fechaAfiliacion);
    this.form.get('activo').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo);
    this.form.get('estado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estado);
    this.form.get('estadoColor').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoColor);
    this.form.get('estadoDescripcion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoDescripcion);
    this.form.get('estadoDescripcionColor').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoDescripcionColor);
    this.form.get('edad').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].edad);
    this.form.get('idEstado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idEstado);
    this.form.get('idProductoEdad').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoEdad);
    this.form.get('nroPoliza').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroPoliza);
    this.form.get('rutaTerminosCondiciones').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].rutaTerminosCondiciones);

    this.ConsultarCartera();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      idProducto: [0],
      idProductoUnico: [0],
      nroDocumento: [''],
      idAplicacion: [0],
      idAliado: [0],
      nombresApellidos: [''],
      fechaAfiliacion: [new Date()],
      activo: [false],
      producto: [''],
      estado: [''],
      estadoColor: [''],
      estadoDescripcion: [''],
      estadoDescripcionColor: [''],
      edad: [0],
      idEstado: [0],
      idProductoEdad: [0],
      nroPoliza: [''],
      rutaTerminosCondiciones: [''],
    });
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('GestionAfiliadosComponent', JSON.stringify(this.parametrosPrincipal));
  }
  ConsultarCartera() {
    this.mostrarCargando = true;
    this.gestionAfiliadoService.ConsultarCartera(this.form.value)
              .subscribe((resp: GestionAfiliado_Cartera[]) =>{
                this.mostrarCargando = false;
                this.listaDatos = resp;
                this.recargarLista();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  MostrarTerminosCondiciones(): boolean {
    return this.utilitariosService.VerificarContieneDatosTexto(this.form.get('rutaTerminosCondiciones').value);
  }
  MostrarEdad() {
    return this.utilitariosService.VerificarContieneDatosTexto(this.form.get('edad').value);
  }
}
